import Hero from './components/Hero';
import Reviews from './components/Reviews';
import ProductCategories from './components/ProductCategories';
import AboutUs from './components/AboutUs';
import Gallery from './components/Gallery';
import CTAInstagram from './components/CTAInstagram';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import DevDisclaimerPopup from '../../components/feature/DevDisclaimerPopup';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function HomePage() {
  return (
    <div className="bg-[#1a1a1a] min-h-screen">
      <DevDisclaimerPopup />
      <WhatsAppButton />
      <Navbar />
      <Hero />
      <Reviews />
      <ProductCategories />
      <AboutUs />
      <Gallery />
      <CTAInstagram />
      <Footer />
    </div>
  );
}
